import MenuItem, { LinkContainer } from "@components/MenuItem"
import MenuItemExpandable, {
  anchorStylesSideNav,
  anchorStylesSideNavItem,
} from "@components/MenuItemExpandable"
import { getIn } from "@utils/index"
import { FilterFunnelProps, MenuDataProps } from "@utils/types"
import { getShopURLForBrandDeviceType, getShopURLForDevice } from "@utils/urls"
import * as R from "ramda"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  overflow: hidden;

  ${LinkContainer} {
    padding: 18px 10px 18px 20px;
  }
`

interface BrandFilterProps {
  data: MenuDataProps
  deviceTypeSlug: any
  filterFunnel: FilterFunnelProps
}

const BrandFilter: React.FC<BrandFilterProps> = ({
  data,
  deviceTypeSlug,
  filterFunnel,
}) => {
  const getShopURL = (slug) => {
    const thisFilterFunnel = getIn(
      filterFunnel,
      `brand.${deviceTypeSlug}.${slug}`
    )
    return thisFilterFunnel
      ? getShopURLForDevice(thisFilterFunnel.slug)
      : getShopURLForBrandDeviceType(slug, deviceTypeSlug)
  }

  const formatBrand = ({ brandName, brandSlug }) => ({
    label: brandName,
    link: getShopURL(brandSlug),
  })

  const deviceTypeData = data[deviceTypeSlug] || {}
  const brands = getIn(deviceTypeData, "brands", [])
  const brandsToShow = getIn(deviceTypeData, "brandsToShow")
  const formattedBrands = React.useMemo(() => brands.map(formatBrand), [data])

  const renderedBrands = brandsToShow
    ? R.slice(0, brandsToShow, formattedBrands)
    : formattedBrands
  const expandableBrands: any = brandsToShow
    ? R.slice(brandsToShow, formattedBrands.length, formattedBrands)
    : []

  return (
    <Container>
      {renderedBrands.map((props) => (
        <MenuItem key={props.label} {...props} />
      ))}
      {expandableBrands.length > 0 && (
        <MenuItemExpandable
          anchorContainerStyles={anchorStylesSideNav}
          anchorItemStyles={anchorStylesSideNavItem}
          items={expandableBrands}
          label={`View ${expandableBrands.length} More`}
        />
      )}
    </Container>
  )
}

export default BrandFilter
